"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _Icon = _interopRequireDefault(require("@react/react-spectrum/Icon"));

var _svgs = require("../../lib/svgs");

var _reactIntl = require("react-intl");

var _useIngest = _interopRequireDefault(require("../../hooks/useIngest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var overlayStyle = {
  pointerEvents: 'none'
};
/**
 * AnnotationToggle component.
 * @returns {ReactElement} markup
 */

var AnnotationToggle = function AnnotationToggle(_ref) {
  var commentsSetShowAnnotations = _ref.commentsSetShowAnnotations,
      visible = _ref.visible,
      isAnnotationsVisible = _ref.isAnnotationsVisible,
      onAnnotationToggle = _ref.onAnnotationToggle,
      disable = _ref.disable;
  var ccxIngest = (0, _useIngest.default)();

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var handleAnnotationToggle = (0, _react.useCallback)(function () {
    var newToggleState = !isAnnotationsVisible;
    commentsSetShowAnnotations(newToggleState);
    newToggleState ? ccxIngest.fireEvent(ccxIngest.events.annotationToggleVisible) : ccxIngest.fireEvent(ccxIngest.events.annotationToggleHidden);
    onAnnotationToggle(newToggleState);
  }, [onAnnotationToggle, commentsSetShowAnnotations, ccxIngest, isAnnotationsVisible]);
  var icon;
  var tooltipTextId;
  var className;

  if (isAnnotationsVisible) {
    icon = /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "M"
    }, _svgs.visibilityIcon);
    tooltipTextId = 'comments.filter.annotation-toggle.hide';
    className = 'annotation-visible';
  } else {
    icon = /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "M"
    }, _svgs.visibilityOffIcon);
    tooltipTextId = 'comments.filter.annotation-toggle.show';
    className = 'annotation-hidden';
  }

  var ariaLabel = formatMessage({
    id: 'comments.filter.annotation-toggle.show'
  });
  var tooltipText = formatMessage({
    id: tooltipTextId
  });

  if (visible) {
    return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
      placement: "left",
      style: overlayStyle,
      trigger: "hover"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      "aria-label": ariaLabel,
      "aria-pressed": isAnnotationsVisible,
      className: "annotation-toggle-icon ".concat(className),
      "data-testid": "annotation-switch",
      disabled: disable,
      icon: icon,
      onClick: handleAnnotationToggle,
      variant: "tool"
    }), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, tooltipText));
  }

  return null;
};

AnnotationToggle.defaultProps = {
  disable: false,
  isAnnotationsVisible: false,
  onAnnotationToggle: function onAnnotationToggle() {},
  visible: true
};
AnnotationToggle.propTypes = {
  commentsSetShowAnnotations: _propTypes.default.func.isRequired,
  disable: _propTypes.default.bool,
  isAnnotationsVisible: _propTypes.default.bool,
  onAnnotationToggle: _propTypes.default.func,
  visible: _propTypes.default.bool
};
var _default = AnnotationToggle;
exports.default = _default;